export default __webpack_public_path__ + "static/media/K2D-Thin.c8078950.ttf";